<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="90px" inline size="mini">
      <el-form-item label="用户信息">
        <el-input v-model="query.user" clearable placeholder="请输入用户信息"></el-input>
      </el-form-item>
      <!-- <el-form-item label="用户状态">
        <el-select v-model="query.state" placeholder="请选择用户状态">
          <el-option label="正常" value="1"></el-option>
          <el-option label="封禁" value="2"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="period"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="创建日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <!-- <el-button class="resetBtn" type="warning" size="mini" @click="custody">重置</el-button> -->
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="userList" style="width: 100%" height="650px" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="uuid" label="用户ID" width="160"></el-table-column>
        <el-table-column prop="nickname" label="用户昵称" width="220">
          <template slot-scope="scope">
            <el-avatar :size="38" :src="scope.row.headImage" @error="errorHandler" style="vertical-align: middle; margin-right: 10px">
              <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"/>
            </el-avatar>
            {{scope.row.nickname}}
          </template>
        </el-table-column>
        <el-table-column prop="cellphone" label="用户手机" width="150"></el-table-column>
        <el-table-column label="用户渠道" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.channel === 1">支付宝</el-tag>
            <el-tag type="success" v-else>微信</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用户状态" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === 1" @click="editUserStatus(2, scope.row.uuid)" style="cursor: pointer">正常</el-tag>
            <el-tag type="warning" v-else @click="editUserStatus(1, scope.row.uuid)" style="cursor: pointer">封禁</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="200"></el-table-column>
        <!-- <el-table-column label="缴纳押金" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isDeposit === 1">已缴纳</el-tag>
            <el-tag type="warning" v-else>未缴纳</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="自动退还押金" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.autoRefundDeposit === 1">自动</el-tag>
            <el-tag type="warning" v-else>不自动</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="depositOrderUuid" label="押金订单编号" width="250"></el-table-column> -->
        <el-table-column label="是否预约" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isLease === 1">是</el-tag>
            <el-tag type="warning" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="unusedMoney" label="余额/元" width="145" align="right">
          <template slot-scope="scope">
            <div class="numberingBox" @click="openWallet(scope.row)">
              {{scope.row.unusedMoney}}
              <i class="el-icon-coin"></i>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-wallet" size="small" @click="jumpWallet(scope.row.uuid)">钱包</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <el-dialog title="用户钱包 (Esc 退出)" :visible.sync="walletDialogVisible" fullscreen>
      <div class="wallet">
        <el-card>
          <el-form :model="queryIncome" label-width="90px" inline size="mini">
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="periodIncome"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <!-- <el-button class="resetBtn" type="warning" size="mini" @click="custody">重置</el-button> -->
            <el-button type="primary" size="mini" @click="searchIncome">搜索</el-button>
            <el-button type="success" size="mini" @click="excelDetail">明细导出</el-button>
          </el-form>
          <!-- 表格数据展示区域 -->
          <el-table :data="incomeList" style="width: 100%" height="650px" border stripe>
            <!-- 展开行区域 -->
            <el-table-column type="expand">
              <template slot-scope="scope">
                <el-form label-width="90px" label-position="left" class="expand">
                  <el-form-item label="用户ID">
                    <span>{{ scope.row.sourceUuid }}</span>
                  </el-form-item>
                  <el-form-item label="钱包ID">
                    <span>{{ scope.row.walletUuid }}</span>
                  </el-form-item>
                  <el-form-item label="预约订单号">
                    <span>{{ scope.row.leaseOrderUuid }}</span>
                  </el-form-item>
                  <el-form-item label="支付订单号">
                    <span>{{ scope.row.payOrderUuid }}</span>
                  </el-form-item>
                  <el-form-item label="备注">
                    <span>{{ scope.row.remark }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="uuid" label="流水号" width="235"></el-table-column>
            <el-table-column prop="amount" label="流水金额(元)"></el-table-column>
            <el-table-column prop="lastAmount" label="余额(元)"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column prop="port" label="收益/支出">
              <template slot-scope="scope">
                <span v-if="scope.row.port === 1">收益</span>
                <span v-else-if="scope.row.port === -1">支出</span>
                <span v-else>空</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 1">押金</span>
                <span v-else-if="scope.row.type === 2">充值</span>
                <span v-else-if="scope.row.type === 3">扣款</span>
                <span v-else-if="scope.row.type === 6">返还押金</span>
                <span v-else-if="scope.row.type === 7">押金抵扣</span>
                <span v-else-if="scope.row.type === 8">退款</span>
                <span v-else-if="scope.row.type === 11">资金信用冻结</span>
                <span v-else-if="scope.row.type === 12">资金信用解冻</span>
                <span v-else-if="scope.row.type === 13">资金信用抵扣</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页区域 -->
          <el-pagination
            @size-change="pageSizeChangeIncome"
            @current-change="CurrentPageChangeIncome"
            :current-page="queryIncome.curPage"
            :page-sizes="[5, 10, 15]"
            :page-size="queryIncome.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSizeIncome"
          ></el-pagination>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { list, statement, excel, editUser } from '@/API/user'
export default {
  name: 'user',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,
        cellphone: '',
        nickname: '',
        state: '',
        ctEnd: '',
        ctStart: ''
      },
      // 总数据条数
      total: 0,
      // 创建开始-结束时间段
      period: [],
      // 用户列表
      userList: [],

      walletDialogVisible: false,
      periodIncome: [],
      queryIncome: {
        walletUuid: '',
        sourceType: '1',
        curPage: 1,
        pageSize: 10,
        ctStart: '',
        ctEnd: ''
      },
      incomeList: [],
      totalSizeIncome: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  created() {
    this.getUserList()
  },
  methods: {
    // 获取预约列表
    async getUserList() {
      const { data: res } = await list(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.userList = res.data.entities
      this.total = res.data.totalSize
    },
    // 重置按钮点击事件
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.period = []
      this.getUserList()
    },
    // 搜索按钮点击事件
    seach() {
      this.query.curPage = 1
      if (this.period != null && this.period !== []) {
        this.query.ctStart = this.period[0]
        this.query.ctEnd = this.period[1]
      } else {
        this.query.ctStart = ''
        this.query.ctEnd = ''
      }
      this.getUserList()
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getUserList()
    },
    // 监听curPage
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.getUserList()
    },
    // 进入钱包
    // 进入钱包
    async openWallet(row) {
      this.periodIncome = []
      this.incomeList = []
      this.totalSizeIncome = 0
      this.walletUuid = row.walletUuid
      this.queryIncome.walletUuid = row.walletUuid

      this.walletDialogVisible = true
    },
    // 获取收益明细
    async queryIncomeList() {
      const { data: res } = await statement(this.queryIncome)
      if (res.code !== 200) return this.$message.error(res.message)
      this.incomeList = res.data.entities
      this.totalSizeIncome = res.data.totalSize
    },
    searchIncome() {
      this.queryIncome.curPage = 1
      if (this.periodIncome != null && this.periodIncome !== []) {
        this.queryIncome.ctStart = this.periodIncome[0]
        this.queryIncome.ctEnd = this.periodIncome[1]
      } else {
        this.queryIncome.ctStart = ''
        this.queryIncome.ctEnd = ''
      }
      this.queryIncomeList()
    },
    // 重置按钮点击触发
    custodyIncome() {
      this.period = []
      this.queryIncome = {
        walletUuid: this.walletUuid,
        sourceType: '11',
        curPage: 1,
        pageSize: 10
      }
      this.queryIncomeList()
    },
    // 监听pageSize的变化
    pageSizeChangeIncome(newSize) {
      this.queryIncome.pageSize = newSize
      this.queryIncomeList()
    },
    // 监听当前页码值的变化
    CurrentPageChangeIncome(newPage) {
      this.queryIncome.curPage = newPage
      this.queryIncomeList()
    },
    // 明细导出
    async excelDetail() {
      if (this.periodIncome.length === 0) return this.$message.error('请选择导出的收益明细日期')
      const { data: res } = await excel(this.queryIncome).catch(err => {
        if (err.response) {
          if (err.response.status === 701) {
            return this.$message.error('请筛选后再导出')
          } else if (err.response.status === 702) {
            return this.$message.error('无筛选记录')
          }
        }
        return this.$message.error('系统繁忙，请稍候再试')
      })
      if (!res) {
        return
      }
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', '用户资金明细-' + new Date().getTime() + '.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    errorHandler() {
      return true
    },
    editUserStatus(status, userUuid) {
      this.$confirm('是否修改状态', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await editUser({
          status: status,
          userUuid: userUuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.seach()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.resetBtn {
  margin-left: 50px;
}
.el-card {
  .el-pagination {
    margin-top: 30px;
  }
}
.numberingBox {
  cursor: pointer;
}
</style>
